const UTILS = {
  async PromisesSequential(PromiseArr) {
    let res = [];
    for (let i = 0; i < PromiseArr.length; i++) {
      res.push(await PromiseArr[i]);
    }
    return res;
  },
  GetRandomUniqId() {
    return "_" + Math.random().toString(36).substr(2, 9);
  },
  async AddItemsToCart(items_to_add) {
    return await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items: items_to_add }),
    });
  },
  FormatMoney(value) {
    return Shopify.formatMoney(value, $("body").data("money-format"));
  },
};

document.addEventListener("alpine:init", () => {
  Alpine.data("CustomBuildbox", () => ({
    product_handle: "",
    bundle_products: [],
    bundle_collection: null,
    selected_products: [],
    variants_to_add: [],
    collections: {
      NC: nc_collections,
      WB: wb_collections,
      GC: gc_collections,
    },
    purchaseOption: "onetime",
    flags: {
      allow_subscription: false,
      manually_selected: false,
      isSubscription: false,
      isOnetime: false,
      is_NC: false,
      is_WB: false,
      is_GC: false,
      include_free_item: true,
    },
    showModal: false,
    showOneTimePurchaseModal: false,
    modalSelectionMade: true,
    oneTimePurchaseDecision: false,
    frequency: 4,
    subscribe_discount_percent: 10,
    free_tin_product: {
      NC: nc_free_tin,
      WB: wb_free_tin,
      GC: wb_free_tin,
    },

    totalPacksSelected() {
      return this.bundle_products.reduce((total, product) => {
        let packsForThisProduct = 0;

        if (product.selected_variant && product.selected_variant.option1) {
          const optionText = product.selected_variant.option1;
          const matches = optionText.match(/\d+/);

          if (matches) {
            const numberOfRefills = parseInt(matches[0], 10);

            if (product.handle.includes("nespresso")) {
              packsForThisProduct = Math.ceil(
                (product.qty * numberOfRefills) / 10
              );
            } else {
              packsForThisProduct = product.qty * numberOfRefills;
            }
          } else {
            packsForThisProduct = product.qty;
          }
        } else {
          packsForThisProduct = product.qty;
        }
        return total + packsForThisProduct;
      }, 0);
    },

    isPackSelected() {
      return this.bundle_products.some((product) => product.qty > 0);
    },

    getTotalIndividualItems() {
      return this.bundle_products.reduce((total, product) => {
        if (!product.handle.includes("pack")) {
          return total + product.qty;
        }
        return total;
      }, 0);
    },

    canCheckout() {
      const totalItems = this.totalPacksSelected();

      if (!this.flags.isSubscription) {
        return totalItems >= 1;
      }

      if (this.flags.is_NC) {
        return totalItems >= 6;
      }

      if (this.flags.is_WB || this.flags.is_GC) {
        return totalItems >= 2;
      }

      return true;
    },

    selectedVariantIsRefillPack() {
      return (
        this.selected_variant &&
        this.selected_variant.option1 &&
        this.selected_variant.option1.includes("Refills")
      );
    },

    mounted() {
      let am = this;
      am.LoadCollection();

      am.bundle_products.forEach((product) => {
        if (product.variants && product.variants.length > 0) {
          product.selected_variant = product.variants[0];
        }
      });

      am.$watch("purchaseOption", (newValue) => {
        am.flags.isSubscription = am.purchaseOption == "subscribe";
        am.flags.isOnetime = !am.flags.isSubscription;
        am.UpdateVariantsToAdd();
      });

      am.$watch("selected_products", am.UpdateVariantsToAdd.bind(am));
      am.$watch("frequency", am.UpdateVariantsToAdd.bind(am));
      am.$watch("flags.isSubscription", am.UpdateVariantsToAdd.bind(am));
      am.$watch("flags.include_free_item", am.UpdateVariantsToAdd.bind(am));
      am.$watch("variants_to_add", am.CheckSubscription.bind(am));
    },

    LoadCollection() {
      let am = this;
      am.product_handle = am.$el.dataset.product;
      let collection_type = "";
      switch (am.product_handle) {
        case "nespresso-compatible-pods":
          collection_type = "NC";
          break;
        case "ground-coffee":
          collection_type = "GC";
          break;
        case "whole-bean":
          collection_type = "WB";
          break;
      }
      am.flags.is_NC = collection_type == "NC";
      am.flags.is_GC = collection_type == "GC";
      am.flags.is_WB = collection_type == "WB";
      am.bundle_products =
        am.collections[collection_type][0].collection.products;

      console.log("Products", am.bundle_products);
    },

    modalIndex: null,

    toggleQuickView(index) {
      this.modalIndex = this.modalIndex === index ? null : index;
      console.log("Toggling quick view to:", this.modalIndex);
    },

    closeModal() {
      this.modalIndex = null;
      console.log("Modal closed.");
    },

    e_UpdateProductQty(e, productIndex) {
      let newQuantity = parseInt(e.target.value, 10);
      if (isNaN(newQuantity)) {
        newQuantity = 0;
      }
      let product = this.bundle_products[productIndex];
      product.qty = newQuantity;
      this.UpdateSelectedItems();

      this.UpdateProductPriceDisplay(product);
      this.UpdateSelectedItems();
      this.GetTotalPrice();
    },

    UpdateProductPriceDisplay(product) {
      if (product.selected_variant) {
        let newPrice = product.selected_variant.price * product.qty;
        product.displayPrice = UTILS.FormatMoney(newPrice);
      } else {
        console.log(
          "No variant selected or product does not have a selected variant."
        );
      }
    },

    async e_AddItemsAndCheckout(e) {
      let am = this;
      this.UpdateSelectedItems();
      if (am.purchaseOption === "onetime") {
        am.showOneTimePurchaseModal = true;
        if (am.oneTimePurchaseDecision) {
          await am.addPaidTinAndStickers();
        }
      } else if (am.purchaseOption === "subscribe") {
        am.showModal = true;
      } else {
        await am.processCheckout();
      }
    },

    handleOneTimePurchaseDecision(decision) {
      this.oneTimePurchaseDecision = decision;
      if (decision) {
        this.addPaidTinAndStickers();
      }
    },

    addPaidTinAndStickers() {
      if (this.purchaseOption !== "onetime") {
        console.log(
          "Skipping addition of paid tin for non-one-time purchase mode."
        );
        return;
      }

      let tinVariantId = this.flags.is_NC
        ? "40648843952212"
        : this.flags.is_WB || this.flags.is_GC
        ? "40648992620628"
        : null;
      if (
        tinVariantId &&
        !this.variants_to_add.some((v) => v.id === tinVariantId)
      ) {
        this.variants_to_add.push({
          quantity: 1,
          id: tinVariantId,
          properties: { _added_tin_and_stickers: true },
        });
        console.log("Added paid tin for one-time purchase.");
      }
    },

    async handleModalDecision(includeFreeTin) {
      this.flags.include_free_item = includeFreeTin;
      this.modalSelectionMade = true;
    },

    async continueToCheckout() {
      if (
        this.oneTimePurchaseDecision &&
        !this.variants_to_add.some(
          (variant) =>
            variant.id === "40648843952212" || variant.id === "40648992620628"
        )
      ) {
        await this.addPaidTinAndStickers();
      }
      this.showModal = false;
      this.showOneTimePurchaseModal = false;
      await this.processCheckout();
    },

    async processCheckout() {
      await UTILS.AddItemsToCart(this.variants_to_add);
      fetch("/cart.js")
        .then((res) => res.json())
        .then(console.log);
      window.location.href = "/checkout";
    },

    UpdateSelectedItems() {
      let am = this;
      let items_with_qty = am.bundle_products.filter((p) => p.qty > 0);
      let total_qty = items_with_qty.reduce((sum, item) => sum + item.qty, 0);

      let collection;

      am.CheckSubscription();

      if (am.flags.is_NC) {
        collection = am.collections.NC.find(
          (item) => item.handle == "nespresso-pods"
        ).collection;
      }

      if (am.flags.is_WB) {
        collection = am.collections.WB.find(
          (item) => item.handle == "whole-bean"
        ).collection;
      }

      if (am.flags.is_GC) {
        collection = am.collections.GC.find(
          (item) => item.handle == "ground-coffee"
        ).collection;
      }

      if (!collection) return;
      am.bundle_collection = collection;

      am.selected_products = collection.products.filter((product) => {
        let matching_item = items_with_qty.find(
          (_p) => _p.title == product.title
        );
        if (!matching_item) return;
        product.qty = matching_item.qty;
        return product;
      });
    },

    getShortDescription(product) {
      if (!product.selected_variant) {
        return "Please select a variant and quantity";
      }

      const match = product.selected_variant.option1.match(/\d+/);
      if (!match) {
        return "Invalid quantity count";
      }

      const quantity = parseInt(match[0], 10);
      if (product.handle.includes("nespresso")) {
        const numberOfPacks = Math.ceil(quantity / 10);
        return `${numberOfPacks} x PACKS OF 10 PODS`;
      } else if (
        product.handle.includes("ground") ||
        product.handle.includes("whole")
      ) {
        return `${quantity}x 200G REFILL BAG${quantity > 2 ? "S" : ""}`;
      }

      return `${quantity}x PACKS OF ITEMS`;
    },

    selectedVariantId: null,

    UpdateSelectedVariant(variantId, product) {
      const selectedVariant = product.variants.find((v) => v.id === variantId);
      if (selectedVariant) {
        this.$nextTick(() => {
          product.selected_variant = selectedVariant;
          this.UpdateProductPriceDisplay(product);
        });

        this.UpdateVariantsToAdd();
        this.UpdateSelectedItems();
        this.GetTotalPrice();
      } else {
        console.error("Selected variant not found in product variants.");
      }
    },

    getVariantOption(variant, optionName) {
      const option = variant.options.find((opt) => opt.name === optionName);
      return option ? option.values[0] : "";
    },

    updatePrice() {
      if (this.product.selected_variant) {
        this.product.price = this.getProductPrice(
          this.product.selected_variant
        );
      }
    },

    getProductPrice(variant) {
      return variant.price;
    },

    UpdateVariantsToAdd() {
      let am = this;
      let bundleID = UTILS.GetRandomUniqId();

      let variants_to_add = am.bundle_products.map((product) => {
        let variant = product.selected_variant || product.variants[0];

        let variant_to_add = {
          quantity: product.qty,
          id: variant.id,
          title: product.title,
          price: variant.price,
          properties: {
            _custom_bundleID: bundleID,
          },
        };

        if (
          am.flags.isSubscription &&
          product.selling_plan_groups &&
          product.selling_plan_groups.length > 0
        ) {
          let sellingPlanGroup = product.selling_plan_groups.find(
            (group) => group.name === `Delivery every ${am.frequency} weeks`
          );

          if (sellingPlanGroup) {
            let sellingPlan = sellingPlanGroup.selling_plans[0];

            if (sellingPlan) {
              variant_to_add.selling_plan = sellingPlan.id;
            } else {
              console.error(
                `No matching selling plan found for the selected frequency (${am.frequency} weeks) and product.`
              );
            }
          } else {
            console.error(
              `No matching selling plan group found for the product with frequency ${am.frequency} weeks.`
            );
          }
        }
        return variant_to_add;
      });

      if (am.flags.isSubscription && am.flags.include_free_item) {
        let free_item = am.flags.is_NC
          ? am.free_tin_product.NC
          : am.flags.is_WB
          ? am.free_tin_product.WB
          : am.free_tin_product.GC;
        variants_to_add.push({
          quantity: 1,
          id: free_item.variants[0].id,
          properties: {
            _custom_bundleID: bundleID,
            _free_item: true,
          },
        });
      }

      am.variants_to_add = variants_to_add;
    },

    GetProductColorScheme(product) {
      return [
        `--prod-bg-title: ${product.mf.bundle_title_bg_color}`,
        `--prod-bg-meta: ${product.mf.bundle_meta_bg_color}`,
        `--prod-bg-tagline: ${product.mf.bundle_tagline_bg_color}`,
      ].join(";");
    },

    GetItemPrice(product) {
      let am = this;
      let variant = product.selected_variant;
      if (!variant) {
        return "Please select a variant";
      }

      let price = variant.price;

      if (am.bundle_collection) {
        let bundle_variant = [
          ...am.bundle_collection.products.flatMap((p) => p.variants),
        ].find((v) => v.id === variant.id && v.product_title === product.title);
        if (bundle_variant) {
          price = bundle_variant.price;
        }
      }

      if (am.flags.isSubscription) {
        price *= 1 - am.subscribe_discount_percent / 100;
      }

      return UTILS.FormatMoney(price);
    },

    GetTotalPrice(type) {
      let total_price = this.bundle_products.reduce((sum, product) => {
        if (product.selected_variant) {
          return sum + product.qty * product.selected_variant.price;
        }
        return sum;
      }, 0);

      if (this.flags.isSubscription && type === "subscription") {
        total_price *= 1 - this.subscribe_discount_percent / 100;
      }

      return UTILS.FormatMoney(total_price);
    },

    GetTotalQty() {
      let am = this;
      return am.variants_to_add
        .filter((item) => !item.properties["_free_item"])
        .reduce((sum, v) => sum + v.quantity, 0);
    },

    GetMinQtySubscription() {
      let am = this;
      let min_qty = 1;

      if (am.isIndividualItem) {
        if (am.flags.is_NC) {
          min_qty = 6;
        } else {
          min_qty = 2;
        }
      }

      return min_qty;
    },

    GetMinimumReqQty() {
      let am = this;
      let min_qty = 1;
      if (am.flags.isSubscription) {
        min_qty = am.GetMinQtySubscription();
      }
      return min_qty;
    },
    CheckSubscription() {
      let am = this;
      let is_MinQtySubscribe = am.GetTotalQty() >= am.GetMinQtySubscription();
      let is_SixOrMoreItems = am.GetTotalQty() >= 6;
      am.flags.allow_subscription = is_MinQtySubscribe || is_SixOrMoreItems;
      if (!am.flags.manually_selected) {
      }
    },
  }));
});

var sectionElement = document.querySelector(
  "section.custom-box-builder-product"
);

if (sectionElement) {
  var divElement = sectionElement.querySelector(".product__information");

  if (divElement) {
    divElement.classList.remove("one-half");

    divElement.classList.add("one-whole");
  }
}

let isScrolling;

if (document.querySelector(".CustomBuildbox")) {
  window.addEventListener(
    "scroll",
    function () {
      window.clearTimeout(isScrolling);
      isScrolling = setTimeout(function () {
        var stickyBar = document.querySelector(".sticky-bar");
        if (stickyBar) {
          if (window.scrollY > 0) {
            stickyBar.style.display = "block";
          } else {
            stickyBar.style.display = "none";
          }
        }
      }, 66);
    },
    false
  );
}

document.querySelectorAll(".purchase-option").forEach(function (option) {
  option.addEventListener("click", function (e) {
    if (e.target !== this.querySelector('input[type="radio"]')) {
      this.querySelector('input[type="radio"]').click();
    }
  });
});


